import SnackContext from './SnackContext'

const SnackConsumer = SnackContext.Consumer ;

export default SnackConsumer ;